var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "client"
  }, [_c('div', {
    staticClass: "animated fadeInDown"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('b-card', {
    attrs: {
      "size": "modal-lg"
    },
    on: {
      "ok": function($event) {
        _vm.addHandovermodal = false
      }
    }
  }, [_c('form', {
    attrs: {
      "autocomplete": "off"
    }
  }, [_c('loader', {
    attrs: {
      "isLoading": _vm.is_Loading
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('span', {
    staticClass: "mdltitle"
  }, [_vm._v(" " + _vm._s(_vm.$t('supportRequest.addRequest')) + " ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('supportRequest.requestFor'))), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Requesttype),
      expression: "Requesttype"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    class: {
      'form-control': true,
      'error': _vm.errors.has('Request For')
    },
    attrs: {
      "name": "Requesttype",
      "id": "Request For"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.Requesttype = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.changetype]
    }
  }, [_c('option', {
    attrs: {
      "selected": "",
      "disabled": "",
      "value": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('supportRequest.selectRequestFor')))]), _vm._v(" "), (_vm.user_type == 'system_user' || _vm.user_type == 'warehouse_user') ? _c('option', {
    attrs: {
      "value": "orderallocation",
      "selected": ""
    }
  }, [_vm._v("Order Allocation")]) : _vm._e(), _vm._v(" "), (_vm.user_type == 'system_user') ? _c('option', {
    attrs: {
      "value": "orderstatusUpdate",
      "selected": ""
    }
  }, [_vm._v("Order Status Update")]) : _vm._e(), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Uniwareorderpush",
      "selected": ""
    }
  }, [_vm._v("Uniware Order Push")]), _vm._v(" "), (_vm.user_type == 'system_user' || _vm.user_type == 'warehouse_user') ? _c('option', {
    attrs: {
      "value": "UniwareInventarySink",
      "selected": ""
    }
  }, [_vm._v("Uniware Inventory Sync")]) : _vm._e(), _vm._v(" "), (_vm.user_type == 'system_user') ? _c('option', {
    attrs: {
      "value": "PODeletion",
      "selected": ""
    }
  }, [_vm._v("Purchase Order Deletion")]) : _vm._e(), _vm._v(" "), (_vm.user_type == 'system_user') ? _c('option', {
    attrs: {
      "value": "RTOInScanIssue",
      "selected": ""
    }
  }, [_vm._v("RTO InScan Issue")]) : _vm._e(), _vm._v(" "), (_vm.user_type == 'system_user') ? _c('option', {
    attrs: {
      "value": "UpdateExpiry",
      "selected": ""
    }
  }, [_vm._v("Update Product Expiry ")]) : _vm._e(), _vm._v(" "), (_vm.user_type == 'system_user') ? _c('option', {
    attrs: {
      "value": "UpdateReturnExpiry",
      "selected": ""
    }
  }, [_vm._v("Update Returns Expiry ")]) : _vm._e(), _vm._v(" "), (_vm.user_type == 'system_user' || _vm.user_type == 'warehouse_user') ? _c('option', {
    attrs: {
      "value": "returnsPutAwayIssue",
      "selected": ""
    }
  }, [_vm._v("Returns Putaway Issue")]) : _vm._e(), _vm._v(" "), (_vm.user_type == 'system_user') ? _c('option', {
    attrs: {
      "value": "deleteOrder",
      "selected": ""
    }
  }, [_vm._v("Delete Order")]) : _vm._e(), _vm._v(" "), (_vm.user_type == 'system_user') ? _c('option', {
    attrs: {
      "value": "resolveExcessgrn",
      "selected": ""
    }
  }, [_vm._v("Resolve Excess GRN Issue")]) : _vm._e(), _vm._v(" "), (_vm.user_type == 'system_user') ? _c('option', {
    attrs: {
      "value": "updateImageUniToWMS",
      "selected": ""
    }
  }, [_vm._v("Update Image Uniware to WMS")]) : _vm._e(), _vm._v(" "), (_vm.user_type == 'system_user' || _vm.user_type == 'warehouse_user') ? _c('option', {
    attrs: {
      "value": "pickerAssignmentBulk",
      "selected": ""
    }
  }, [_vm._v("Picker Assignment Bulk")]) : _vm._e()]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Request For')),
      expression: "errors.has('Request For')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('Request For')) + " ")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }), _vm._v(" "), (_vm.Requesttype == 'FilpcartRTD') ? _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('supportRequest.rTDOrderIDS')))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "id": "ponoFlt",
      "placeholder": _vm.$t('supportRequest.rtoIrderPlaceholder')
    },
    model: {
      value: (_vm.MultiorderIDS),
      callback: function($$v) {
        _vm.MultiorderIDS = $$v
      },
      expression: "MultiorderIDS"
    }
  })], 1)]) : _vm._e(), _vm._v(" "), (_vm.Requesttype == 'FilpcartDispatched') ? _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('supportRequest.boxIDS')))]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('Box Ids')
    },
    attrs: {
      "type": "text",
      "id": "Box Ids",
      "name": "Box Ids",
      "placeholder": _vm.$t('supportRequest.boxIDSPlaceHolder')
    },
    model: {
      value: (_vm.MultiorderBoxIDS),
      callback: function($$v) {
        _vm.MultiorderBoxIDS = $$v
      },
      expression: "MultiorderBoxIDS"
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Box Ids')),
      expression: "errors.has('Box Ids')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(" " + _vm._s(_vm.$t('supportRequest.boxIDSError')) + "\n                  ")])], 1)]) : _vm._e(), _vm._v(" "), (_vm.Requesttype == 'FilpcartDispatched') ? _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('supportRequest.dispatchedToUser')))]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dispatchedtouser),
      expression: "dispatchedtouser"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('Dispatched To User')
    },
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('supportRequest.dispatchedToUserPlaceHolder'),
      "name": "Dispatched To User",
      "id": "Dispatched To User"
    },
    domProps: {
      "value": (_vm.dispatchedtouser)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.dispatchedtouser = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Dispatched To User')),
      expression: "errors.has('Dispatched To User')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.$t('supportRequest.dispatchedToUserError')) + "\n                ")])])]) : _vm._e(), _vm._v(" "), (_vm.Requesttype == 'Uniwareorderpush') ? _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Order Id"), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pushorderid),
      expression: "pushorderid"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('Order Id')
    },
    attrs: {
      "type": "text",
      "placeholder": "Order Id",
      "name": "Order Id",
      "id": "Order Id"
    },
    domProps: {
      "value": (_vm.pushorderid)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.pushorderid = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Order Id')),
      expression: "errors.has('Order Id')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("Order ID Is Required")])])]) : _vm._e(), _vm._v(" "), (_vm.Requesttype == 'FilpcartDispatched') ? _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('supportRequest.dispatchedByUser')))]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dispatchedbyuser),
      expression: "dispatchedbyuser"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('Dispatched By User')
    },
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('supportRequest.dispatchedByUserPlaceHolder'),
      "id": "Dispatched By User"
    },
    domProps: {
      "value": (_vm.dispatchedbyuser)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.dispatchedbyuser = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Dispatched By User')),
      expression: "errors.has('Dispatched By User')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('Dispatched By User')) + "\n                ")])])]) : _vm._e(), _vm._v(" "), (_vm.Requesttype == 'PODeletion') ? _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('supportRequest.purchaseOrderID')))]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.purchaseorderidlist),
      expression: "purchaseorderidlist"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('Purchase Order ID')
    },
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('supportRequest.purchaseOrderIDPlaceHolder'),
      "name": "Purchase Order ID",
      "id": "Purchase Order ID"
    },
    domProps: {
      "value": (_vm.purchaseorderidlist)
    },
    on: {
      "change": function($event) {
        _vm.CountPOIDs()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.purchaseorderidlist = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.MultiorderArrFlag) ? _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.OverOrdersErr) + "\n                ")]) : _vm._e(), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Purchase Order ID')),
      expression: "errors.has('Purchase Order ID')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.$t('supportRequest.purchaseOrderError')) + "\n                ")])])]) : _vm._e(), _vm._v(" "), (_vm.Requesttype == 'RTOInScanIssue') ? _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('supportRequest.aWBNumber')))]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.awbno),
      expression: "awbno"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('AWB Number')
    },
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('supportRequest.aWBNumberPlaceHolder'),
      "name": "AWB Number",
      "id": "AWB Number"
    },
    domProps: {
      "value": (_vm.awbno)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.awbno = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.MultiorderArrFlag) ? _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.OverOrdersErr) + "\n                ")]) : _vm._e(), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('AWB Number')),
      expression: "errors.has('AWB Number')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.$t('supportRequest.aWBNumberError')) + "\n                ")])])]) : _vm._e(), _vm._v(" "), (_vm.Requesttype == 'RTOInScanIssue') ? _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('common.courierCompany'))), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.couriername),
      expression: "couriername"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    class: {
      'form-control': true,
      'error': _vm.errors.has('CourierCompany')
    },
    attrs: {
      "name": "CourierCompany",
      "id": "CourierCompany"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.couriername = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "selected": "",
      "disabled": "",
      "value": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('common.courierCompanyPlaceHolder')))]), _vm._v(" "), _vm._l((_vm.listCourierData), function(warehouse_obj) {
    return _c('option', {
      domProps: {
        "value": warehouse_obj.couriername
      }
    }, [_vm._v(_vm._s(warehouse_obj.couriername))])
  })], 2), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('CourierCompany')),
      expression: "errors.has('CourierCompany')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.$t('common.courierCompanyError')))])])]) : _vm._e(), _vm._v(" "), (this.buttonflag) ? _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('supportRequest.orderId')))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.orderid1),
      expression: "orderid1"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('Order ID')
    },
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('supportRequest.orderIdPlaceHolder'),
      "name": "Order ID",
      "id": "Order ID",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.orderid1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.orderid1 = $event.target.value
      }
    }
  })])]) : _vm._e(), _vm._v(" "), (this.buttonflag) ? _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('supportRequest.customerName')))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.custname),
      expression: "custname"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('Customer Name')
    },
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('supportRequest.customerNamePlaceHolder'),
      "name": "Customer Name",
      "id": "Customer Name",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.custname)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.custname = $event.target.value
      }
    }
  })])]) : _vm._e(), _vm._v(" "), (this.buttonflag) ? _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('supportRequest.sku')))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sku),
      expression: "sku"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('SKU')
    },
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('supportRequest.skuPlaceHolder'),
      "name": "SKU",
      "id": "SKU",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.sku)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.sku = $event.target.value
      }
    }
  })])]) : _vm._e(), _vm._v(" "), (this.buttonflag) ? _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('supportRequest.totalQuantity')))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.totalquantity),
      expression: "totalquantity"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('Total Quantity')
    },
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('supportRequest.totalQuantityPlaceHolder'),
      "name": "Total Quantity",
      "id": "Total Quantity",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.totalquantity)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.totalquantity = $event.target.value
      }
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.Requesttype == 'orderstatusUpdate') ? _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('supportRequest.orderStatusUpdate'))), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.statusupdate),
      expression: "statusupdate"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    class: {
      'form-control': true,
      'error': _vm.errors.has('Order Status Update')
    },
    attrs: {
      "name": "statusupdate",
      "id": "Order Status Update"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.statusupdate = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "selected": "",
      "disabled": "",
      "value": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('supportRequest.selectOrderStatusUpdate')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "allocated",
      "selected": ""
    }
  }, [_vm._v("Allocated")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "packed",
      "selected": ""
    }
  }, [_vm._v("Packed")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "picked",
      "selected": ""
    }
  }, [_vm._v("Picked")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "dispatched",
      "selected": ""
    }
  }, [_vm._v("Dispatched")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Unpack",
      "selected": ""
    }
  }, [_vm._v("Unpack")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Restore",
      "selected": ""
    }
  }, [_vm._v("Restore Order")])]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Order Status Update')),
      expression: "errors.has('Order Status Update')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('Order Status Update')) + " ")])])]) : _vm._e(), _vm._v(" "), (_vm.Requesttype == 'orderstatusUpdate' || _vm.Requesttype == 'getorderfrommultiseller' || _vm.Requesttype == 'Multisellerpackingdetails' || _vm.statusupdate == 'packed' || _vm.statusupdate == 'dispatched' && _vm.statusupdate != 'Unpack' || _vm.statusupdate == 'Restore') ? _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('supportRequest.orderId')))]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [(_vm.statusupdate == 'allocated') ? _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.orderidlist),
      expression: "orderidlist"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('Order ID')
    },
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('supportRequest.orderIdListPlaceHolder'),
      "name": "Order ID",
      "id": "Order ID"
    },
    domProps: {
      "value": (_vm.orderidlist)
    },
    on: {
      "change": function($event) {
        _vm.CountOrderIDs()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.orderidlist = $event.target.value
      }
    }
  }) : _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.orderid),
      expression: "orderid"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('Order ID')
    },
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('supportRequest.orderIdPlaceHolder'),
      "name": "Order ID",
      "id": "Order ID"
    },
    domProps: {
      "value": (_vm.orderid)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.orderid = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.MultiorderArrFlag) ? _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.OverOrdersErr) + "\n                ")]) : _vm._e(), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Order ID')),
      expression: "errors.has('Order ID')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.$t('supportRequest.orderIdError')) + "\n                ")])])]) : _vm._e(), _vm._v(" "), (_vm.Requesttype == 'returnsPutAwayIssue') ? _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Returns Type"), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.returnType),
      expression: "returnType"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    class: {
      'form-control': true,
      'error': _vm.errors.has('Returns Type')
    },
    attrs: {
      "name": "Returns Type",
      "id": "returnType"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.returnType = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "selected": "",
      "disabled": "",
      "value": ""
    }
  }, [_vm._v("Select Return Type")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "rto",
      "selected": ""
    }
  }, [_vm._v("RTO")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "sr",
      "selected": ""
    }
  }, [_vm._v("RVP")])]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Returns Type')),
      expression: "errors.has('Returns Type')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("Returns Type is required ")])])]) : _vm._e(), _vm._v(" "), (_vm.Requesttype == 'returnsPutAwayIssue') ? _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("AWB Number"), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.awbnumber),
      expression: "awbnumber"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('AWB Number')
    },
    attrs: {
      "type": "text",
      "placeholder": "AWB Number",
      "name": "AWB Number",
      "id": "WB Number"
    },
    domProps: {
      "value": (_vm.awbnumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.awbnumber = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('AWB Number')),
      expression: "errors.has('AWB Number')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("AWB Number Is Required")])])]) : _vm._e(), _vm._v(" "), (_vm.Requesttype == 'returnsPutAwayIssue') ? _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Rack Type"), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.racktype),
      expression: "racktype"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('Rack Type')
    },
    attrs: {
      "type": "text",
      "placeholder": "Rack Type",
      "name": "Rack Type",
      "id": "Rack Type"
    },
    domProps: {
      "value": (_vm.racktype)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.racktype = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Rack Type')),
      expression: "errors.has('Rack Type')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("Rack Type Is Required")])])]) : _vm._e(), _vm._v(" "), (_vm.Requesttype == 'deleteOrder') ? _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Order Id"), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.delorderid),
      expression: "delorderid"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('Order Id')
    },
    attrs: {
      "type": "text",
      "placeholder": "Order Id",
      "name": "Order Id",
      "id": "Order Id"
    },
    domProps: {
      "value": (_vm.delorderid)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.delorderid = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Order Id')),
      expression: "errors.has('Order Id')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("Order Id Is Required")])])]) : _vm._e(), _vm._v(" "), (_vm.Requesttype == 'deleteOrder') ? _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Product ID"), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.delproductid),
      expression: "delproductid"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('Product ID')
    },
    attrs: {
      "type": "text",
      "placeholder": "Product ID",
      "name": "Product ID",
      "id": "Product ID"
    },
    domProps: {
      "value": (_vm.delproductid)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.delproductid = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Order Id')),
      expression: "errors.has('Order Id')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("Product ID Is Required")])])]) : _vm._e(), _vm._v(" "), (_vm.Requesttype == 'deleteOrder') ? _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Item ID"), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.delitemid),
      expression: "delitemid"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('Item ID')
    },
    attrs: {
      "type": "text",
      "placeholder": "Item ID",
      "name": "Item ID",
      "id": "Item ID"
    },
    domProps: {
      "value": (_vm.delitemid)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.delitemid = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Item ID')),
      expression: "errors.has('Item ID')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("Item ID Is Required")])])]) : _vm._e(), _vm._v(" "), (_vm.Requesttype == 'deleteOrder') ? _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Box ID")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.delboxid),
      expression: "delboxid"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "text",
      "placeholder": "Box ID",
      "name": "Box ID",
      "id": "Box ID"
    },
    domProps: {
      "value": (_vm.delboxid)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.delboxid = $event.target.value
      }
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.Requesttype == 'resolveExcessgrn') ? _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("DR No."), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.invreferenceid),
      expression: "invreferenceid"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('DR No')
    },
    attrs: {
      "type": "text",
      "placeholder": "DR No",
      "name": "DR No",
      "id": "DR No."
    },
    domProps: {
      "value": (_vm.invreferenceid)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.invreferenceid = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('DR No')),
      expression: "errors.has('DR No')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("DR Id Is Required")])])]) : _vm._e(), _vm._v(" "), (_vm.Requesttype == 'resolveExcessgrn') ? _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Product Id"), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.grnproductid),
      expression: "grnproductid"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('Product Id')
    },
    attrs: {
      "type": "text",
      "placeholder": "Product Id",
      "name": "Product Id",
      "id": "Product Id"
    },
    domProps: {
      "value": (_vm.grnproductid)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.grnproductid = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Product Id')),
      expression: "errors.has('Product Id')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("Product Id Is Required")])])]) : _vm._e(), _vm._v(" "), (_vm.Requesttype == 'resolveExcessgrn') ? _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Remove Accept Qty"), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.removeacceptqty),
      expression: "removeacceptqty"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('Remove Accept Qty')
    },
    attrs: {
      "type": "text",
      "placeholder": "Remove Accept Qty",
      "name": "Remove Accept Qty",
      "id": "Remove Accept Qty"
    },
    domProps: {
      "value": (_vm.removeacceptqty)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.removeacceptqty = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Remove Accept Qty')),
      expression: "errors.has('Remove Accept Qty')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("Remove Excess Qty Is Required")])])]) : _vm._e(), _vm._v(" "), (_vm.Requesttype == 'resolveExcessgrn') ? _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Remove Reject Qty"), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.removerejectqty),
      expression: "removerejectqty"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('Remove Reject Qty')
    },
    attrs: {
      "type": "text",
      "placeholder": "Remove Reject Qty",
      "name": "Remove Reject Qty",
      "id": "Remove Reject Qty"
    },
    domProps: {
      "value": (_vm.removerejectqty)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.removerejectqty = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Remove Reject Qty')),
      expression: "errors.has('Remove Reject Qty')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("Remove Excess Reject Qty Is Required")])])]) : _vm._e(), _vm._v(" "), (_vm.Requesttype == 'resolveExcessgrn') ? _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Item Id"), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.grnitemid),
      expression: "grnitemid"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('Item Id')
    },
    attrs: {
      "type": "text",
      "placeholder": "Item Id",
      "name": "Item Id",
      "id": "Item Id"
    },
    domProps: {
      "value": (_vm.grnitemid)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.grnitemid = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Item Id')),
      expression: "errors.has('Item Id')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("Remove Excess Reject Qty Is Required")])])]) : _vm._e(), _vm._v(" "), (_vm.Requesttype == 'resolveExcessgrn') ? _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Remove Short Qty"), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.removeshortqty),
      expression: "removeshortqty"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('Remove Short Qty')
    },
    attrs: {
      "type": "text",
      "placeholder": "Remove Short Qty",
      "name": "Remove Short Qty",
      "id": "Remove Short Qty"
    },
    domProps: {
      "value": (_vm.removeshortqty)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.removeshortqty = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Remove Short Qty')),
      expression: "errors.has('Remove Short Qty')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("Remove Short Qty Is Required")])])]) : _vm._e(), _vm._v(" "), (_vm.Requesttype == 'Multisellerpackingdetails' || _vm.statusupdate == 'packed' || _vm.statusupdate == 'dispatched' || _vm.statusupdate == 'Unpack' || _vm.statusupdate == 'Restore') ? _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('supportRequest.boxID')))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.BoxID),
      expression: "BoxID"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: (''),
      expression: "''"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('BoxID')
    },
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('supportRequest.boxIDPlaceHolder'),
      "name": "BoxID",
      "id": "BoxID"
    },
    domProps: {
      "value": (_vm.BoxID)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.BoxID = $event.target.value
      }
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.Requesttype == 'UpdateExpiry') ? _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('printProductDetails.productId')) + " "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ProductID),
      expression: "ProductID"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('ProductID')
    },
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('printProductDetails.productIdPlaceHolder'),
      "name": "ProductID",
      "id": "ProductID"
    },
    domProps: {
      "value": (_vm.ProductID)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.ProductID = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('ProductID')),
      expression: "errors.has('ProductID')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.$t('printProductDetails.ProductIdError')) + " ")])])]) : _vm._e(), _vm._v(" "), (_vm.Requesttype == 'UpdateExpiry') ? _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('warehouseRacks.rackId'))), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.RackID),
      expression: "RackID"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('RackID')
    },
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('warehouseRacks.rackIdPlaceHolder'),
      "name": "RackID",
      "id": "RackID"
    },
    domProps: {
      "value": (_vm.RackID)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.RackID = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('RackID')),
      expression: "errors.has('RackID')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.$t('warehouseRacks.rackIDError')) + " ")])])]) : _vm._e(), _vm._v(" "), (_vm.Requesttype == 'UpdateExpiry') ? _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('printProductDetails.expiryDate')) + " "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-input-group', {
    attrs: {
      "left": "<i class='\tfa fa-calendar'></i>"
    }
  }, [_c('date-picker', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "lang": "en",
      "type": "date",
      "placeholder": _vm.$t('common.datePlaceholder'),
      "format": "YYYY-MM-DD",
      "id": "ExpiryDate",
      "name": "ExpiryDate"
    },
    model: {
      value: (_vm.ExpiryDate),
      callback: function($$v) {
        _vm.ExpiryDate = $$v
      },
      expression: "ExpiryDate"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('ExpiryDate')),
      expression: "errors.has('ExpiryDate')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.$t('printProductDetails.expiryDateError')) + " ")])], 1)]) : _vm._e(), _vm._v(" "), (_vm.Requesttype == 'UpdateReturnExpiry') ? _c('div', {
    staticClass: "form-group row"
  }) : _vm._e(), _vm._v(" "), (_vm.Requesttype == 'UpdateReturnExpiry') ? _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('supportRequest.returnsType'))), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.returnsType),
      expression: "returnsType"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    class: {
      'form-control': true,
      'error': _vm.errors.has('return expiryDate Update')
    },
    attrs: {
      "name": "returnsType",
      "placeholder": _vm.$t('supportRequest.boxIDPlaceHolder'),
      "id": "Return ExpiryDate Update"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.returnsType = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "selected": "",
      "disabled": "",
      "value": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('supportRequest.returnsTypePlaceHolder')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "rto",
      "selected": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('returnReceiptReport.rto')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "rvp",
      "selected": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('returnReceiptReport.rvp')))])]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('returnsType')),
      expression: "errors.has('returnsType')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.$t('common.returnTypeError')) + " ")])])]) : _vm._e(), _vm._v(" "), (_vm.Requesttype == 'UpdateReturnExpiry') ? _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('common.awbNo')))]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.awbno),
      expression: "awbno"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('AWB Number')
    },
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('common.aWBNumberPlaceHolder'),
      "name": "AWB Number",
      "id": "AWB Number"
    },
    domProps: {
      "value": (_vm.awbno)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.awbno = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('AWB Number')),
      expression: "errors.has('AWB Number')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.$t('common.EmptyawbError')) + "\n              ")])])]) : _vm._e(), _vm._v(" "), (_vm.Requesttype == 'UpdateReturnExpiry') ? _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('common.expiryDate')) + " "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-calendar'></i>"
    }
  }, [_c('date-picker', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "lang": "en",
      "type": "date",
      "placeholder": _vm.$t('common.datePlaceholder'),
      "format": "YYYY-MM-DD",
      "id": "ExpiryDate",
      "name": "ExpiryDate"
    },
    model: {
      value: (_vm.ExpiryDate),
      callback: function($$v) {
        _vm.ExpiryDate = $$v
      },
      expression: "ExpiryDate"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('ExpiryDate')),
      expression: "errors.has('ExpiryDate')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.$t('common.expiryDateError')) + " ")])], 1)]) : _vm._e(), _vm._v(" "), (_vm.Requesttype == 'updateImageUniToWMS') ? _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("SKU"), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.skustring),
      expression: "skustring"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('sku')
    },
    attrs: {
      "type": "text",
      "placeholder": "SKU",
      "name": "sku",
      "id": "sku"
    },
    domProps: {
      "value": (_vm.skustring)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.skustring = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('sku')),
      expression: "errors.has('sku')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("SKU Is Required")])])]) : _vm._e(), _vm._v(" "), (_vm.Requesttype == 'pickerAssignmentBulk') ? _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('orders.orderPicker')))]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-window-maximize'></i>"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pickerid),
      expression: "pickerid"
    }],
    staticClass: "form-control",
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "name": "pickerid"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.pickerid = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "selected": "",
      "value": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('orders.selectPicker')))]), _vm._v(" "), _vm._l((_vm.pickerListData), function(user_obj) {
    return _c('option', {
      domProps: {
        "value": user_obj.userid
      }
    }, [_vm._v(_vm._s(user_obj.email))])
  })], 2)]), _vm._v(" "), (_vm.pickerid == '') ? _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.SelectPickerErr))]) : _vm._e()], 1)]) : _vm._e(), _vm._v(" "), (_vm.Requesttype == 'pickerAssignmentBulk') ? _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', {
    attrs: {
      "for": "customTextarea"
    }
  }, [_vm._v("Order IDs "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ordertext),
      expression: "ordertext"
    }],
    staticClass: "form-control scrollable-textarea",
    attrs: {
      "placeholder": "Enter order IDs, comma‑separated",
      "id": "customTextarea",
      "rows": "10",
      "cols": "5"
    },
    domProps: {
      "value": (_vm.ordertext)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.ordertext = $event.target.value
      }, _vm.validateInput]
    }
  }), _vm._v(" "), _c('small', {
    staticClass: "text-muted"
  }, [_vm._v(_vm._s(_vm.count) + "/400 IDs")]), _c('br'), _vm._v(" "), (_vm.orderTextErr) ? _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.orderTextErr))]) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "inwardfooter form-actions float-right"
  }, [(!this.buttonflag) ? _c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button",
      "disabled": _vm.MultiorderArrFlag,
      "variant": "primary"
    },
    on: {
      "click": _vm.CheckStacusandSave
    }
  }, [_c('i', {
    staticClass: "fa fa-save"
  }), _vm._v(" " + _vm._s(_vm.$t('common.continous')))]) : _c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button",
      "variant": "primary"
    },
    on: {
      "click": _vm.FinalInScan
    }
  }, [_c('i', {
    staticClass: "fa fa-save"
  }), _vm._v(" " + _vm._s(_vm.$t('common.saveBtn')))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button",
      "size": "sm"
    },
    on: {
      "click": _vm.resetaddDeatilsForm
    }
  }, [_c('i', {
    staticClass: "fa fa-ban"
  }), _vm._v(" " + _vm._s(_vm.$t('common.resetBtn')))]), _vm._v("  \n            ")])])], 1)])], 1)])])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-6f5f2382", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6f5f2382","hasScoped":true}!./src/views/components/supportrequest/supportrequest.component.html
// module id = 1828
// module chunks = 0